import { createContext } from 'react'
import type {
  User,
  UserListParams,
  UserListResponse,
  UserRole,
  UserStatus,
} from '../../../types/user'

export interface UserContextValue {
  orgId: string

  // Server data
  pageData: UserListResponse | undefined
  users: User[]
  isLoading: boolean
  isFetching: boolean
  isError: boolean
  error: unknown

  // Derived stats (computed across current page)
  stats: { total: number; active: number; invited: number }

  // Client-side filtered rows
  filtered: User[]

  // Search (debounced → also sent to server)
  keyword: string
  setKeyword: (value: string) => void

  // Client-side filters
  roleFilter: 'All' | UserRole
  setRoleFilter: (role: 'All' | UserRole) => void
  statusFilter: 'all' | UserStatus
  setStatusFilter: (status: 'all' | UserStatus) => void

  // Pagination
  listParams: UserListParams
  currentPage: number
  totalPages: number
  totalItems: number
  fullTotal: number
  canGoBack: boolean
  canGoNext: boolean
  showingStart: number
  showingEnd: number
  goToPrevPage: () => void
  goToNextPage: () => void
  goToPage: (page: number) => void
}

export const UserContext = createContext<UserContextValue | undefined>(
  undefined,
)
